module.exports = __webpack_public_path__ + "img/preview-icon.b1a712a4.svg";